// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"2da26a086961281f97eb","293":"db1c4280f502cd4c99ba","518":"93ddc253501c2251314f","779":"d02ef4bc091580ab1045"}[chunkId] + ".js";
};